function isObjectEmpty(obj) {
  for(var prop in obj) {
    if(Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

Handlebars.registerHelper("ifCond", function (v1, operator, v2, options) {
  switch (operator) {
    case "==":
      return v1 == v2 ? options.fn(this) : options.inverse(this);
    case "===":
      return v1 === v2 ? options.fn(this) : options.inverse(this);
    case "!=":
      return v1 != v2 ? options.fn(this) : options.inverse(this);
    case "!==":
      return v1 !== v2 ? options.fn(this) : options.inverse(this);
    case "<":
      return v1 < v2 ? options.fn(this) : options.inverse(this);
    case "<=":
      return v1 <= v2 ? options.fn(this) : options.inverse(this);
    case ">":
      return v1 > v2 ? options.fn(this) : options.inverse(this);
    case ">=":
      return v1 >= v2 ? options.fn(this) : options.inverse(this);
    case "&&":
      return v1 && v2 ? options.fn(this) : options.inverse(this);
    case "||":
      return v1 || v2 ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
});

Handlebars.registerHelper("unlessCond", function (v1, operator, v2, options) {
  switch (operator) {
    case "==":
      return !(v1 == v2) ? options.fn(this) : options.inverse(this);
    case "===":
      return !(v1 === v2) ? options.fn(this) : options.inverse(this);
    case "!=":
      return !(v1 != v2) ? options.fn(this) : options.inverse(this);
    case "!==":
      return !(v1 !== v2) ? options.fn(this) : options.inverse(this);
    case "<":
      return !(v1 < v2) ? options.fn(this) : options.inverse(this);
    case "<=":
      return !(v1 <= v2) ? options.fn(this) : options.inverse(this);
    case ">":
      return !(v1 > v2) ? options.fn(this) : options.inverse(this);
    case ">=":
      return !(v1 >= v2) ? options.fn(this) : options.inverse(this);
    case "&&":
      console.log("my test should be true::", !(v1 && v2));
      return !(v1 && v2) ? options.fn(this) : options.inverse(this);
    case "||":
      return !(v1 || v2) ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
});

/**
 *
 * @param input
 * @param value
 * @returns {string}
 */
Handlebars.registerHelper("isSelected", function (input, value) {
  return input == value ? "selected" : "";
});

/**
 * Check is checkbox checked
 *
 * @param input
 * @param value
 * @returns {string}
 */
Handlebars.registerHelper("isChecked", function (input, value) {
  if (_.isArray(input)) {
    return _.indexOf(input, value) !== -1 ? "checked" : "";
  }

  return input === value ? "checked" : "";
});

/**
 * return object property by key
 * @param obj
 * @param key
 * @param prop
 * @returns {*}
 */
Handlebars.registerHelper("lookupProp", function (obj, key, prop) {
  // console.log(obj, key, prop);
  return obj && obj[key] && obj[key][prop];
});
Handlebars.registerHelper("isNotEmpty", function (arr) {
  return Boolean(arr) && Boolean(arr.length) && !isObjectEmpty(arr[0]);
});

Handlebars.registerHelper("isEmpty", function (arr) {
  return arr[0] === {}
});

Handlebars.registerHelper("ifAll", function () {
  var options = Array.prototype.pop.call(arguments);

  if (arguments.length === _.filter(arguments).length) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper("compare", function (v1, v2, options) {
  //console.log(options);
  //console.log(v1, v2, v1===v2);
  if (v1 === v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper("notCompare", function (v1, v2, options) {
  if (v1 !== v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper("compareClass", function (v1, v2, options) {
  if (_.contains(v1.split(" "), v2)) {
    return options.fn(this);
  }

  return options.inverse(this);
});

Handlebars.registerHelper("notCompareClass", function (v1, v2, options) {
  if (!_.contains(v1.split(" "), v2)) {
    return options.fn(this);
  }

  return options.inverse(this);
});

/**
 * return array starting from count - 1
 * @param context
 * @param count
 * @param options
 * @returns {string}
 */
Handlebars.registerHelper("eachFrom", function (context, count, options) {
  var ret = "";

  context.slice(count - 1).forEach(function (elem) {
    ret += options.fn(elem);
  });

  return ret;
});

Handlebars.registerHelper("firstLetter", function (string) {
  return _.isString(string) ? string.charAt(0) : string;
});

Handlebars.registerHelper("setValToDouble", function (val) {
  if (_.isString(val)) {
    return val;
  }
  return val ? val * 2 : "-";
});

Handlebars.registerHelper("stringWithSuffix", function (str, suffix) {
  return _.isString(str) && str.length > 0 ? str + suffix : str;
});

Handlebars.registerHelper("firstLetterWithSuffix", function (str, suffix) {
  return _.isString(str) && str.length > 0 ? str.charAt(0) + suffix : str;
});

Handlebars.registerHelper("lookupPropCompleteTips", function (obj, key, prop) {
  var arr = obj[key] && obj[key][prop];
  var result = _.map(arr, function (value) {
    if (value.status !== "scheduled") {
      return value;
    }
  });
  return _.compact(result);
});

Handlebars.registerHelper(
  "lookupPropTotallyCompleteTips",
  function (obj, key, prop) {
    var arr = obj[key] && obj[key][prop];
    var result = _.map(arr, function (value) {
      if (value.status === "complete") {
        return value;
      }
    });
    return _.compact(result);
  }
);

Handlebars.registerHelper("lookupPropPlayingTips", function (obj, key, prop) {
  var arr = obj[key] && obj[key][prop];
  var result = _.map(arr, function (value) {
    if (value.status == "playing") {
      return value;
    }
  });
  return _.compact(result);
});

Handlebars.registerHelper("lookupPropScheduledTips", function (obj, key, prop) {
  var arr = obj[key] && obj[key][prop];
  var result = _.map(arr, function (value) {
    if (value.status == "scheduled") {
      return value;
    }
  });
  return _.compact(result);
});

Handlebars.registerHelper("convertUnixTimeStamp", function (date) {
  date = new Date(date * 1000);

  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;

    return hours + ":" + minutes + " " + ampm;
  }

  return formatAMPM(date) + ", " + date.getDate() + "/" + (date.getMonth() + 1);
});

Handlebars.registerHelper("convertTime", function (date) {
  var month_names = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    d = new Date(date),
    day = d.getDate(),
    month_index = d.getMonth(),
    h = d.getHours(),
    m = d.getMinutes(),
    s = d.getSeconds(),
    dd = "AM";

  if (h >= 12) {
    h = h - 12;
    dd = "PM";
  }
  if (h == 0) {
    h = 12;
  }

  m = m < 10 ? "0" + m : m;
  s = s < 10 ? "0" + s : s;

  return (
    month_names[month_index] +
    "&nbsp;&nbsp;" +
    day +
    ",&nbsp;&nbsp;" +
    h +
    "." +
    m +
    dd
  );
});

Handlebars.registerHelper("convertTimeV2", function (date) {
  var month_names = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ],
    day_names = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    d = new Date(date),
    day = d.getDate(),
    dn = d.getDay(),
    month_index = d.getMonth(),
    h = d.getHours(),
    m = d.getMinutes(),
    s = d.getSeconds(),
    dd = "AM";

  if (h >= 12) {
    h = h - 12;
    dd = "PM";
  }
  if (h == 0) {
    h = 12;
  }

  m = m < 10 ? "0" + m : m;
  s = s < 10 ? "0" + s : s;

  return (
    day_names[dn] +
    " " +
    month_names[month_index] +
    "&nbsp;" +
    day +
    ",&nbsp;" +
    h +
    ":" +
    m +
    dd
  );
});

/**
 * Return formatted number.
 * is_sign            - show '+' / '-' or not (default false)
 * is_currency        - show '$' or not (default false)
 * concat_with        - append char to number or not (default K)
 * divide_by          - divide number by (default 1.0e+3)
 * prepend_plus       - prepend plus or not (default true)
 * wrap_into_brackets - wrap into brackets or not
 */
Handlebars.registerHelper("kFormat", function (context, options) {
  var number = !isFinite(+context) ? 0 : +context,
    is_sign = options.hash.is_sign || false,
    is_currency = options.hash.is_currency || false,
    concat_with =
      options.hash.concat_with !== undefined
        ? options.hash.concat_with || ""
        : "K",
    divide_by = options.hash.divide_by || 1.0e3,
    prepend_plus =
      options.hash.prepend_plus === undefined
        ? true
        : !!options.hash.prepend_plus,
    zero_is_zero = options.hash.zero_is_zero || false,
    wrap = options.hash.wrap_into_brackets || false,
    decimal_ceil = options.hash.decimal_ceil || false,
    setComas = function (num, divide, is_abs) {
      var num_res = num / divide,
        num_str = is_abs ? Math.abs(num_res) : num_res;

      if (decimal_ceil) {
        num_str = "" + Math.ceil10(num_str, decimal_ceil);
      } else {
        num_str = "" + Math.ceil(num_str);
      }

      return decimal_ceil
        ? num_str
        : num_str.replace(/./g, function (c, i, a) {
            return i && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
          });
    };

  if (is_sign) {
    switch (true) {
      case number > 0:
        return (
          '<span class="number-positive">' +
          (wrap ? "(" : "") +
          (prepend_plus ? "+" : "") +
          (is_currency ? "$" : "") +
          setComas(number, divide_by, true) +
          concat_with +
          (wrap ? ")" : "") +
          "</span>"
        );
        break;
      case number < 0:
        return (
          '<span class="number-negative">' +
          (wrap ? "(" : "") +
          "-" +
          (is_currency ? "$" : "") +
          setComas(number, divide_by, true) +
          concat_with +
          (wrap ? ")" : "") +
          "</span>"
        );
        break;
      case number === 0:
        return (
          '<span class="number-zero">' +
          (wrap ? "(" : "") +
          (zero_is_zero ? "0" : "-") +
          (wrap ? ")" : "") +
          "</span>"
        );
        break;
    }
  } else if (!number) {
    return "-";
  }

  return (
    (wrap ? "(" : "") +
    (is_currency ? "$" : "") +
    setComas(number, divide_by) +
    concat_with +
    (wrap ? ")" : "")
  );
});

Handlebars.registerHelper("json", function (obj) {
  return JSON.stringify(obj);
});

Handlebars.registerHelper("log", function (obj) {
  console.log(obj);
});

/**
 * Return formatted version of number, equivalent of PHP’s number_format.
 * http://phpjs.org/functions/number_format/
 *
 * decimals      - number of decimal points (default 0)
 * dec_point     - separator for the decimal point (default '.')
 * thousands_sep - the thousands separator (default ',')
 */
Handlebars.registerHelper("numberFormat", function (number, options) {
  number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+options.hash.decimals)
      ? 0
      : Math.abs(options.hash.decimals),
    sep =
      typeof options.hash.thousands_sep === "undefined"
        ? ","
        : options.hash.thousands_sep,
    dec =
      typeof options.hash.dec_point === "undefined"
        ? "."
        : options.hash.dec_point,
    s = "",
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return "" + (Math.round(n * k) / k).toFixed(prec);
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }

  return s.join(dec);
});

/**
 * a limited 'each' loop.
 * usage: {{#limit items offset="1" limit="5"}} : items 1 thru 6
 * usage: {{#limit items limit="10"}} : items 0 thru 9
 * usage: {{#limit items offset="3"}} : items 3 thru context.length
 * defaults are offset=0, limit=5
 */
Handlebars.registerHelper("limit", function (context, block) {
  var ret = "",
    offset = parseInt(block.hash.offset) || 0,
    limit = parseInt(block.hash.limit) || 5,
    i = offset < context.length ? offset : 0,
    j = limit + offset < context.length ? limit + offset : context.length;

  for (i, j; i < j; i++) {
    ret += block.fn(context[i]);
  }

  return ret;
});

/**
 * Return Cost formatted number.
 * fractionSize - numbers after coma
 * is_sign - return abs or with minus
 * is_currency - is dollar sign needed
 */
Handlebars.registerHelper("costFormat", function (input, options) {
  if (!input) {
    return "-";
  }
  var number = +input,
    abs = Math.abs(number),
    letter = "",
    sign = "$",
    to_fixed = options.hash.to_fixed || 2,
    is_minus = number < 0 && options.hash.is_sign ? "-" : "";

  if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6)) {
    // million
    abs = (abs / Math.pow(10, 6)).toFixed(to_fixed);
    letter = "m";
  } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 2)) {
    // thousand
    abs = (abs / Math.pow(10, 3)).toFixed(0);
    letter = "k";
  }

  if (!options.hash.is_currency) {
    sign = "";
  }

  abs.replace(/./g, function (c, i, a) {
    return i && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
  });

  return is_minus + sign + abs + letter;
});

/**
 * Return truncated string
 * value - how many letters return
 */
Handlebars.registerHelper("truncateStr", function (input, options) {
  return input && _.isString(input)
    ? input.substr(0, options.hash.value || input.length)
    : input;
});

/**
 * Join the elements of an array into a string
 * separator - the separator to be used (default ',')
 */
Handlebars.registerHelper("join", function (context, options) {
  var separator = options.hash.separator || ",";

  return Array.isArray(context) ? context.join(separator) : "";
});

/**
 * Add ordinal suffix for numbers
 */
Handlebars.registerHelper("suffixFormat", function (context) {
  var j = +context % 10,
    k = +context % 100;
  if (j == 1 && k != 11) {
    return context + "st";
  }
  if (j == 2 && k != 12) {
    return context + "nd";
  }
  if (j == 3 && k != 13) {
    return context + "rd";
  }
  return context + "th";
});

/**
 * Add ordinal suffix for numbers in tag
 */
Handlebars.registerHelper("suffixFormatInTag", function (context, tag) {
  var j = +context % 10,
    k = +context % 100;
  if (j == 1 && k != 11) {
    return context + "<" + tag + ">" + "st" + "</" + tag + ">";
  }
  if (j == 2 && k != 12) {
    return context + "<" + tag + ">" + "nd" + "</" + tag + ">";
  }
  if (j == 3 && k != 13) {
    return context + "<" + tag + ">" + "rd" + "</" + tag + ">";
  }
  return context + "<" + tag + ">" + "th" + "</" + tag + ">";
});

/**
 * Return the result of a mathematical operation
 */
Handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
  lvalue = parseFloat(lvalue);
  rvalue = parseFloat(rvalue);

  return {
    "+": lvalue + rvalue,
    "-": lvalue - rvalue,
    "*": lvalue * rvalue,
    "/": lvalue / rvalue,
    "%": lvalue % rvalue,
  }[operator];
});

Handlebars.registerHelper("eval", function () {
  return new Function(
    "return " +
      Array.prototype.slice
        .call(arguments, 0, -1)
        .map(function (arg) {
          return String(arg);
        })
        .join("")
  )();
});

/**
 * Return "-" if value is empty
 */
Handlebars.registerHelper("ifEmptyDash", function (value) {
  if (!value && value !== 0) {
    return "-";
  }

  return value;
});

/**
 * Return "-" if value is empty
 */
Handlebars.registerHelper("ifEmptyOrZeroDash", function (value) {
  if (!value) {
    return "-";
  }

  return value;
});

/**
 * Return "DNP" if value is empty
 */
Handlebars.registerHelper("ifEmptyDNP", function (value) {
  if (!value && value !== 0) {
    return "DNP";
  }

  return value;
});

/**
 * Return 0 if value is empty
 */
Handlebars.registerHelper("ifEmptyZero", function (value) {
  if (!value && value !== 0) {
    return 0;
  }

  return value;
});

/**
 * Return ul list with '|' delimiter
 */
Handlebars.registerHelper("delimiterListMenu", function (arr, delimiter) {
  var new_arr = _.compact(arr);

  new_arr = _.filter(new_arr, function (value) {
    return !value.hide_item;
  });

  return Handlebars.helpers.generateMenuList(new_arr, delimiter);
});

Handlebars.registerHelper("generateMenuList", function (arr, delimiter) {
  var listItems = "";

  _.each(arr, function (value, key) {
    var menu_ternary = "",
      active = value.is_active_sub ? "active" : "",
      class_name = value.className ? value.className : "",
      path = value.path ? value.path : "",
      name = value.name ? value.name : "",
      icon = value.icon ? value.icon : "",
      sub_menu =
        value.sub_menu && value.sub_menu.length ? value.sub_menu : false;

    if (delimiter && key > 0 && !value.hide_item) {
      listItems += '<li><span class="delimiter">' + delimiter + "</span></li>";
    }

    if (sub_menu) {
      menu_ternary =
        '<ul class="clearfix menu-ternary">' +
        Handlebars.helpers.generateMenuList(sub_menu) +
        "</ul>";
    }

    if (!value.hide_item) {
      listItems +=
        '<li class="' +
        active +
        class_name +
        '"><a href="#' +
        path +
        '">' +
        name +
        icon +
        "</a> " +
        menu_ternary +
        " </li>";
    }
  });

  return new Handlebars.SafeString(listItems);
});

/**
 * Return number to Fixed 2
 */
Handlebars.registerHelper("toFixed", function (num, to) {
  var number = parseFloat(num);

  if (!to) {
    to = 2;
  }

  return number.toFixed(to);
});

Handlebars.registerHelper("tabTouchMulti", function (num) {
  var number = parseFloat(num);
  if (number < 100) {
    return number.toFixed(2);
  } else {
    return Math.round(number);
  }
});

/**
 * Return number to Fixed
 * default: 1
 */
Handlebars.registerHelper("numToFixed", function (value, to) {
  var parsed_value = parseFloat(value);

  if (!value || !_.isNumber(parsed_value)) {
    return value;
  }

  to = _.isNumber(to) ? to : 1;

  if (parsed_value % 1 != 0) {
    parsed_value = Math.round10(parsed_value, -1 * to);
  }
  return parsed_value;
});

/**
 * Return number to Fixed <decimals>
 */
Handlebars.registerHelper("toFixedDecimals", function (num, decimals) {
  var number = parseFloat(num);
  return parseFloat(number.toFixed(decimals));
});

/**
 * Return string divided by span
 */
Handlebars.registerHelper("stringDivider", function (str) {
  return "<span>" + str.split(" ").join("</span> <span>") + "</span>";
});

/**
 * Return true if an object is an array, false if it is not
 */
Handlebars.registerHelper("isArray", function (value) {
  return _.isArray(value);
});

/**
 * Return money format string
 */
Handlebars.registerHelper("formatMoney", function (value) {
  var v = parseFloat(value);
  return "$" + v.toFixed(2);
});

/**
 * Return active state for dropdown menu
 */
Handlebars.registerHelper("isActiveState", function (state) {
  var current_state = Backbone.history.location.pathmethod;

  if (current_state && current_state == state) {
    return "active";
  }
});

Handlebars.registerHelper("findProperty", function (obj, key, prop) {
  //console.log(obj, key, prop);
  return (
    obj &&
    _.find(obj, function (obj_keys) {
      return obj_keys[key] === prop;
    })
  ); //obj[key][prop];
});

Handlebars.registerHelper("mixinNumberFormat", function (context, options) {
  return _.mixinNumberFormat(context, options.hash);
});

Handlebars.registerHelper("mixinKMformat", function (context, options) {
  if (context < Math.pow(10, 9) && context >= Math.pow(10, 6)) {
    options.hash.concat_with = "M";
  }

  return _.mixinKformat(context / 1000, options.hash);
});

Handlebars.registerHelper("scoreCheck", function (value, comparator) {
  return value === comparator ? "--" : value;
});

Handlebars.registerHelper("finalsLabel", function (round_id, final_round_id) {
	console.log(round_id, final_round_id);
	// var is_finals = round_id >= final_round_id;
	// var label = is_finals ? 'Finals Week ' : 'Round ';
	// var id = is_finals ? round_id - final_round_id + 1 : round_id;
	// return label + id;
  var is_finals = round_id >= final_round_id;
  var final_value = round_id - final_round_id;
	// var label = (is_finals && (final_value < 2)) ? 'Finals Week ' : 'Round ';
  var label = 'Round ';
  var id = is_finals ? round_id - final_round_id + 1 : round_id;
  if (final_value === 0 || final_value === 1) {
    label = 'Finals Week  ';
    return label + id;
  };
  if (final_value === 2) {
    return "Preliminary Finals"
  };
  if (final_value === 3) {
    return "Grand Final"
  };
	return label + id;
});

Handlebars.registerHelper("finalsJoinsLabel", function (round_id, final_round_id) {
	console.log(round_id, final_round_id);
	var is_finals = round_id >= final_round_id;
	var label = is_finals ? 'FW ' : 'RD ';
	var id = is_finals ? round_id - final_round_id + 1 : round_id;
	return label + id;
});

Handlebars.registerHelper("isDefined", function(value, options) {
  return value !== undefined && value !== null ? options.fn(this) : options.inverse(this);
});